import { DeliveryOptions_BindEvents, DeliveryOptions_Init } from "./gak-DeliveryOptions"
import { FacebookScriptsService } from "./tracking-scripts.js";
import { basketParams } from './gak-DeliveryOptions'
import { debounceScript } from './Debounce.js';
import { loadBasketPanel } from './gak-ProductDetail';
import { ShoppingBasket_UpdateItemCount } from './common';
import { pushRemoveFromCart, pushAddToCart, onCheckout, onCheckoutOption, pushEnhancedEcommerce } from "./enhanced-ecommerce.js";
import Swiper, { Navigation } from 'swiper';

declare var ShoppingBasketParms: any;
declare var basketConfig: any;
declare var bpj: any;

var basketPanel: boolean = false;
var requestBasketUpdate =
    (debounceScript as any)(updateWholeCart,
        500,
        { 'leading': false, 'trailing': true });

var qtyUpdateKeyUp =
    (debounceScript as any)(onQtyKeyUp,
        500,
        { 'leading': false, 'trailing': true });

function showWaitElement(show: any) {
    var waitElem = document.getElementsByClassName("wait-spinner")!.item(0)!;
    if (waitElem) {
        if (show) waitElem.classList.remove('hidden');
        else waitElem.classList.add('hidden');
    }
}

function disableBasketButtons() {
    //Disable +, - and remove buttons
    var buttons = document.querySelectorAll(
        ".order-process-basket button.decrease, \
         .order-process-basket button.increase, \
         .order-process-basket button.remove-order-item-button, \
         .order-process-basket .quantity-select");
    buttons.forEach(function (b) {
        b.classList.add("btn-disabled");
        b.setAttribute("disabled", "");
    });

    var qtys = document.querySelectorAll(".order-process-basket input.js-stepper.quantity");
    qtys.forEach(function (q) {
        q.setAttribute("readonly", "");
    });
}

function onQtyKeyUp(e: any) {
    let inputElement = e.srcElement;
    if (inputElement.readOnly) return;

    let oldValue = parseInt(inputElement.closest('li').getAttribute('data-quantity'));
    let newValue = parseInt(inputElement.value);
    if (isNaN(newValue)) return;
    newValue = sanitizeQtyInput(newValue);
    if (oldValue !== newValue) {
        disableBasketButtons();
        showWaitElement(true);
        updateStepper(e.srcElement);
        inputElement.focus();
    }
}

export function updateWholeCart(newRegionId: any) {
    var basketItems = document.querySelectorAll(".basket-item");
    var form = new FormData();

    if (basketItems)
        basketItems.forEach(function (item, i) {
            var id = item.getAttribute("data-id")!;
            var quantity = item.getAttribute("data-quantity")!;

            form.append(`orderItems[${i}][ID]`, id);
            form.append(`orderItems[${i}][Quantity]`, quantity);
        });

    if (newRegionId) {
        form.append("newRegionId", newRegionId);
    }

    form.append("redirectToShoppingBasket", (!basketPanel).toString());

    fetch(ShoppingBasketParms.UpdateCartURL, {
        method: 'POST',
        body: form
    }).then(response => response.text())
        .then(function (data: any) {
            if (basketPanel) {
                loadBasketPanel();
            }
            else {
                updateBasketContent(data);
            }
            showItemUpdatedAlert();
            showWaitElement(false);
        });
}

function showItemUpdatedAlert() {
    var basketAlert = document.getElementById("basketAlert");
    var alertText = document.querySelector("#basketAlert p");

    if (basketAlert && alertText) {
        basketAlert.className = "[ alert ] [ bg-green-1 text-green text-15 text-md-16 ]";
        alertText.textContent = "Item quantity updated";
    }
}

function showItemRemovedAlert() {
    var basketAlert = document.getElementById("basketAlert");
    var alertText = document.querySelector("#basketAlert p");

    if (basketAlert && alertText) {
        basketAlert.className = "[ alert ] [ bg-red-1 text-red text-15 text-md-16 ]";
        alertText.textContent = "1x item removed from basket";
    }
}

function sanitizeQtyInput(value: number) {
    if (value < 0)
        return 0;
    if (value > 1000)
        return 1000;
    return value;
}

function updateStepper(element: any) {
    var quantityInput = element.parentNode.querySelector("input");
    var li = element.closest("[data-quantity]");
    var productId = li.getAttribute("data-product-id");
    if (quantityInput) {
        var newValue = parseInt(quantityInput.value);
        var oldValue = parseInt(quantityInput.getAttribute('value'));
        var classList = element.classList;
        if (classList.contains("decrease")) {
            newValue--;
        } else if (classList.contains("increase")) {
            newValue++;
        }
        newValue = sanitizeQtyInput(newValue);
        quantityInput.value = newValue;
        quantityInput.setAttribute("value", newValue);
        li.setAttribute("data-quantity", newValue);

        if (oldValue > newValue)
            pushRemoveFromCart(productId, oldValue - newValue);
        else
            pushAddToCart(productId, newValue - oldValue);
    }

    requestBasketUpdate();
}

export function ShoppingBasket_BindEvents(isBasketPanel: boolean = false) {
    basketPanel = isBasketPanel;
    let decreaseBtns = document.querySelectorAll(".stepper button.decrease");
    let increaseBtns = document.querySelectorAll(".stepper button.increase");
    let removeBtns = document.querySelectorAll(".remove-order-item-button");
    let qtyInputs = document.querySelectorAll(".stepper .js-stepper.quantity");

    const quantitySelect = document.querySelectorAll(".quantity-select");

    if (quantitySelect) {
        quantitySelect.forEach(function (element: any) {
             element.addEventListener("change", function () {
                 disableBasketButtons();
                 showWaitElement(true);

                 const li = element.closest("[data-quantity]");
                 li.setAttribute("data-quantity", element.value);
                 requestBasketUpdate();
            });
        });
    }

    if (decreaseBtns) {
        decreaseBtns.forEach(function (element: any) {
            element.addEventListener("click", function () {
                disableBasketButtons();
                showWaitElement(true);
                updateStepper(element);
            });
        });
    }

    if (increaseBtns) {
        increaseBtns.forEach(function (element: any) {
            element.addEventListener("click", function () {
                disableBasketButtons();
                showWaitElement(true);
                updateStepper(element);
            });
        });
    }

    removeBtns.forEach(function (element: any) {
        element.addEventListener("click", function () {
            disableBasketButtons();
            showWaitElement(true);
            var ordermItemId = element.closest("li").getAttribute("data-id");
            removeOrderItem(ordermItemId);
        });
    });

    qtyInputs.forEach(function (qty) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
            qty.addEventListener("blur", qtyUpdateKeyUp);
        } else {
            qty.addEventListener("keyup", qtyUpdateKeyUp);
        }
    });

    const recommended = new Swiper('.swiper.recommended', {
        modules: [Navigation],
        direction: 'horizontal',
        cssMode: true,
        slidesPerView: "auto",
        loop: false,
        speed: 600,
        navigation: {
            nextEl: '.recommended-container .swiper-button-next',
            prevEl: '.recommended-container .swiper-button-prev',
        },
        breakpoints: {
            1024: {
                cssMode: false,
                slidesPerView: 4,
                spaceBetween: 40,
            },
        },
    });
}

export function showBasketError(msg: string) {
    var basketErrorContainer = document.getElementsByClassName("basketErrorContainer")?.item(0);

    if (basketErrorContainer)
        basketErrorContainer.textContent = msg;
}


function removeOrderItem(orderItemId: any) {
    if (orderItemId != null && orderItemId != "") {
        var form = new FormData();
        form.append("orderItemId", orderItemId)
        fetch(ShoppingBasketParms.DestroyOrderItemURL, {
            method: "POST",
            body: form
        }).then((response) => {
            if (response.ok) {
                return response.text();
            }
            showBasketError("Unable to remove from basket, please try again");
        })
            .then(function (data) {
                if (basketPanel) {
                    loadBasketPanel();
                    pushProductRemovalToGA(orderItemId);
                }
                else {
                    pushProductRemovalToGA(orderItemId);
                    updateBasketContent(data);
                }
                showWaitElement(true);
                showItemRemovedAlert();
            });
    }
}


function pushProductRemovalToGA(orderItemId: any) {
    var product = document.querySelector(`[data-id="${orderItemId}"]`);
    if (product) {
        var productId = product.getAttribute("data-product-id");
        if (productId) {
            var quantity = product.getAttribute("data-quantity");
            var quantityNo = 0;

            if (quantity)
                quantityNo = parseInt(quantity);
            else {
                var productDetails = document.querySelector(`[data-product-id='${product.id}']`);

                if (productDetails)
                    quantityNo = parseInt(productDetails.getAttribute("data-quantity") || "0");
            }

            pushRemoveFromCart(productId, quantityNo);
        }
    }
}


function loadShoppingBasket() {
    fetch(basketConfig.basketUrl, {
        method: 'GET',
    }).then(response => response.text())
        .then(function (data: any) {
            updateBasketContent(data);
            pushEnhancedEcommerce();
            onCheckout(1);
        });
}


function updateBasketContent(data: any) {
    var currentBasketContainer = document.getElementById("shoppingBasketContent")

    if (currentBasketContainer)
        currentBasketContainer.innerHTML = data;

    var parser = new DOMParser();
    var html = parser.parseFromString(data, 'text/html');

    if (html) {
        var bpj = (<HTMLInputElement>html.getElementById("bpj")!);
        if (bpj) {
            DeliveryOptions_Init(bpj.value);
            ShoppingBasket_BindEvents(basketPanel);
            if (!basketPanel) {
                DeliveryOptions_BindEvents(true);
            }
        }
        ShoppingBasket_UpdateItemCount();
    }
}

export function ShoppingBasket_ProceedToCheckout(e: any) {
    var theButton = e.currentTarget;
    var deliveryTypeId = (<HTMLInputElement>document.getElementById("deliveryTypeID"));

    if (basketParams && basketParams.OutOfStock && ((deliveryTypeId!.value || '') == '')) {
        // Monkeypatched alert is async... so prevent first!
        e.preventDefault();
        alert("You must select a Delivery Option before Checkout");
        return;
    }

    // Facebook Track code
    // InitiateCheckout
    // Track when people enter the checkout flow (ex. click/landing page on checkout button)

    FacebookScriptsService.addFacebookTracking(false);
    FacebookScriptsService.addFacebookEvent('InitiateCheckout');

    var chosenOption = document.querySelector(".chosenOption span[data-helptext]");

    if (chosenOption) {
        var chosenOptionDesc = chosenOption.getAttribute("data-helptext");

        if (chosenOptionDesc)
            onCheckoutOption(1, chosenOptionDesc);
    }

    var paymentMethod = theButton.getAttribute("data-payment-mehtod");

    onCheckoutOption(1, paymentMethod);

    //(document.getElementById("UpdateStockForm") as any).submit();
}

function toggleFooter() {
    var ToggleButtons = document.querySelectorAll('[data-toggle-parent]');
    if (ToggleButtons.length) {
        ToggleButtons.forEach(function (toggle) {
            if (!toggle.classList.contains('click-bound')) {
                toggle.classList.add('click-bound');
                toggle.addEventListener('click', function (e) {
                    let elem = e.target as HTMLElement;
                    if (elem.getAttribute('aria-expanded') == "false") {
                        elem.setAttribute('aria-expanded', 'true')
                    }
                    else {
                        elem.setAttribute('aria-expanded', 'false');
                    }
                })
            }
        })
    }
}

window.onload = function () {
    loadShoppingBasket();
    toggleFooter();
}